import { render } from "./ReferralNotesOverlay.vue?vue&type=template&id=1523743c&scoped=true&lang=pug"
import script from "./ReferralNotesOverlay.vue?vue&type=script&lang=js"
export * from "./ReferralNotesOverlay.vue?vue&type=script&lang=js"

import "./ReferralNotesOverlay.vue?vue&type=style&index=0&id=1523743c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1523743c"]])

export default __exports__